import { type ObjectSchema, string, object } from 'yup';

import { memberSex } from '@/constants/memberBasicInfo';
import type { Person } from '@/types/person';

export const basicInfoSectionSchema: ObjectSchema<
  Pick<
    Person,
    | 'first_name'
    | 'last_name'
    | 'jurisdiction_id'
    | 'birthday'
    | 'time_zone'
    | 'sex'
    | 'nickname'
    | 'pronouns'
  >
> = object({
  first_name: string().trim().notRequired().label('First name'),
  last_name: string().trim().notRequired().label('Last name'),
  jurisdiction_id: string().notRequired().label('Jurisdiction'),
  birthday: string().notRequired().label('Date of birth'),
  deceased_on: string().notRequired().label('Date of death'),
  time_zone: string().notRequired().label('Time zone'),
  sex: string()
    .oneOf([...memberSex, ''])
    .notRequired()
    .label('Sex'),
  nickname: string().notRequired().label('Nickname'),
  pronouns: string().notRequired().label('Pronouns')
});
